import { ReactElement, StrictMode } from "react";

import { StaticRouter } from "react-router-dom/server";

import { ConfigProvider } from "@atlassiansox/bxp-content-framework";

import {
    AnalyticsProvider,
    OnetrustProvider,
    RouteProvider,
    AnalyticsAttributesProvider
} from "./components";
import { StaticLanguageProvider } from "./components/hooks/use-language";
import { PageModel } from "./models";
import { GlobalStyles } from "./styles";
import { Page } from "./views";

const getEnvironment = (): "production" | "staging" | "development" => {
    const env = process.env["CLIENT_LIBRARY_ENV"] || process.env["NODE_ENV"];
    if (env === "production") return "production";
    if (env === "staging") return "staging";
    return "development";
};

export const APP_ID = "BXP-APP";

export type AppProps = {
    readonly defaultPageModel: PageModel;
};

export const App = ({ defaultPageModel }: AppProps): ReactElement => {
    const variant = defaultPageModel.content.variant || undefined;

    const routePath = defaultPageModel.content.route.content.path;
    const locale = defaultPageModel.locale || "en";

    return (
        <StrictMode>
            <ConfigProvider config={{ environment: getEnvironment() }}>
                <StaticRouter location={routePath}>
                    <StaticLanguageProvider language={locale}>
                        <AnalyticsAttributesProvider
                            value={{
                                eventContainer: "content",
                                path: routePath,
                                pageVariant: variant
                            }}
                        >
                            <RouteProvider value={routePath}>
                                <OnetrustProvider>
                                    <AnalyticsProvider>
                                        <GlobalStyles />
                                        <Page model={defaultPageModel} />
                                    </AnalyticsProvider>
                                </OnetrustProvider>
                            </RouteProvider>
                        </AnalyticsAttributesProvider>
                    </StaticLanguageProvider>
                </StaticRouter>
            </ConfigProvider>
        </StrictMode>
    );
};
